import { usePropertyRentalProvideUnitsLater } from '../../../../../../queries/PropertyFields/RentalUnitsFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components/';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';

interface ProvideRentalUnitsLaterProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const ProvideRentalUnitsLater: React.FC<ProvideRentalUnitsLaterProps> = ({ propertyGuid, isReview = false }) => {
    const label = 'Provide Unit Information Later?';
    const [provideRentalUnitsLater, set_provideRentalUnitsLater] = usePropertyRentalProvideUnitsLater(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        set_provideRentalUnitsLater(e.itemData?.id === 'Yes');
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={provideRentalUnitsLater ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='provideRentalUnitsLater'
                    value={provideRentalUnitsLater}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={true}
                    requiredMessage='This field is required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Large}
                />
            )}
        </>
    );
};
